<template>
  <el-drawer :title="form.id ? '编辑' : '添加'" :visible.sync="drawer" :modal="true" :wrapperClosable="false" size="80%"
             @close="closeDrawer" :modal-append-to-body="false" :direction="direction">

    <!-- title -->
    <div class="drawer_form">
      <el-form :model="form" status-icon :rules="formRules" ref="form" label-width="120px" label-position="top"
               class="demo-ruleForm">
        <div class="form-content">
          <el-row :gutter="20">
            <!-- 一级指标 -->
            <el-col :span="8">
              <div class="first-level-form">
                <el-form-item label="评课标准名称" prop="templateName">
                  <el-input type="text" v-model="form.templateName" placeholder="请输入评课标准名称"
                            autocomplete="off" class="form-input" @blur="validateTemplateName"></el-input>
                </el-form-item>
                <el-form-item label="评课附加提示词" prop="">
                  <el-input type="textarea" rows="4" v-model="form.background"
                            placeholder="请输入评课附加提示词" autocomplete="off" class="form-textarea"></el-input>
                </el-form-item>

                <!-- 新增输入框和添加按钮 -->
                <el-form-item label="一级指标" prop="">
                  <div style="display: flex; gap: 10px; margin-bottom: 15px;">
                    <el-input v-model="newItemText" placeholder="请输入内容" style="flex: 1;"></el-input>
                    <el-button type="primary" @click="addItem">添加</el-button>
                  </div>

                  <!-- 一级指标表格（点击行选中，作为右侧指标的归属） -->
                  <el-table ref="dataTable"
                            :data="indicatorItems.map(item => ({ name: item.name, maxScore: item.maxScore }))"
                            style="width: 100%" row-key="name" v-loading="false"
                            :row-class-name="firstLevelTableRowClassName"
                            @current-change="handleFirstLevelCurrentChange"
                            :highlight-current-row="true" :tree-props="{ hasChildren: false }">
                    <el-table-column align="center" prop="name" label="内容"></el-table-column>
                    <el-table-column align="center" label="分数" width="80">
                      <template slot-scope="scope">
                        {{ calculateFirstLevelScore(scope.row) }} <!-- 自动计算一级指标分数 -->
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button @click="deleteItem(scope.row.name)" type="primary"
                                   size="small">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </div>
            </el-col>

            <!-- 指标（原三级指标，现直接挂在一级指标下） -->
            <el-col :span="16">
              <div class="third-level-form">
                <el-form-item label="二级指标" prop="">
                  <!-- 多选下拉框 - 自动填充表格 -->
                  <div style="margin-bottom: 15px;">
                    <el-select v-model="selectedThirdLevelRules" multiple collapse-tags
                               placeholder="请选择指标" style="width: 100%; min-width: 200px;" filterable
                               @change="onThirdLevelRulesChange">
                      <el-option v-for="rule in thirdLevelRules" :key="rule.id" :label="rule.name"
                                 :value="rule.id"></el-option>
                    </el-select>
                  </div>

                  <!-- 指标表格 -->
                  <el-table
                      :data="flattenedThirdLevelItems().map(item => ({ id: item.id, name: item.name, maxScore: item.maxScore, displayType: item.displayType || '1', width: item.width || 24 }))"
                      style="width: 100%" row-key="id" @current-change="handleThirdLevelCurrentChange"
                      v-loading="false" :highlight-current-row="true"
                      :tree-props="{ hasChildren: false }">
                    <el-table-column align="center" prop="name" label="指标名称"></el-table-column>
                    <el-table-column align="center" label="分数">
                      <template slot-scope="scope">
                        <el-input-number :value="scope.row.maxScore"
                                         @change="updateThirdLevelScore(scope.row.id, $event)" :min="1"
                                         :step="1" style="width: 100px;" size="small"></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="展示类型">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.displayType" style="width: 100px;"
                                   @change="updateThirdLevelDisplayType(scope.row.id, $event)">
                          <el-option label="分数" value="1"></el-option>
                          <el-option label="分|说" value="2"></el-option>
                          <el-option label="分|图" value="3"></el-option>
                          <el-option label="分|说|图" value="4"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="宽度占比">
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.width"
                                   @change="updateThirdLevelWidth(scope.row.id, $event)"
                                   placeholder="请选择"
                                   size="small"
                                   style="width: 100px;">
                          <el-option label="6" :value="6"></el-option>
                          <el-option label="12" :value="12"></el-option>
                          <el-option label="24" :value="24"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button @click="deleteThirdItem(scope.row.id)" type="primary"
                                   size="small">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 底部按钮区域 -->
        <div class="form-footer">
          <el-button @click="closeDrawer" class="cancel-btn">取消</el-button>
          <el-button @click="onSubmit" type="primary" class="submit-btn" :disabled="!editable">
            {{ form.id ? '编辑' : '添加' }}
          </el-button>
        </div>
      </el-form>
      <!-- 编辑模式下，当不可编辑时显示蒙层 -->
      <div v-if="form.id && !editable" class="edit-overlay">
        <div class="edit-overlay-text">禁止编辑</div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {save, rule_list, get_module} from '@/request/api/module'

export default {
  components: {},
  watch: {
    // 监听指标分数变化，自动更新一级分数
    indicatorItems: {
      deep: true,
      handler() {
        // 触发依赖更新，Vue会自动重新计算计算属性
      }
    }
  },
  methods: {
    // 计算一级指标分数：当前一级下所有指标分数之和
    calculateFirstLevelScore(firstLevelItem) {
      const originalFirstLevel = this.indicatorItems.find(item => item.name === firstLevelItem.name);
      if (!originalFirstLevel || !originalFirstLevel.children || originalFirstLevel.children.length === 0) {
        return 0;
      }
      return originalFirstLevel.children.reduce((total, thirdLevelItem) => {
        return total + (thirdLevelItem.maxScore || 0);
      }, 0);
    },

    // 更新指标分数
    updateThirdLevelScore(thirdLevelId, newScore) {
      for (const firstLevel of this.indicatorItems) {
        if (firstLevel.children) {
          const thirdLevel = firstLevel.children.find(item => item.id === thirdLevelId);
          if (thirdLevel) {
            thirdLevel.maxScore = newScore;
            this.$forceUpdate();
            return;
          }
        }
      }
    },

    // 更新指标展示类型
    updateThirdLevelDisplayType(thirdLevelId, newType) {
      for (const firstLevel of this.indicatorItems) {
        if (firstLevel.children) {
          const thirdLevel = firstLevel.children.find(item => item.id === thirdLevelId);
          if (thirdLevel) {
            thirdLevel.displayType = newType;
            this.$forceUpdate();
            return;
          }
        }
      }
    },

    // 更新指标宽度占比
    updateThirdLevelWidth(thirdLevelId, newWidth) {
      for (const firstLevel of this.indicatorItems) {
        if (firstLevel.children) {
          const thirdLevel = firstLevel.children.find(item => item.id === thirdLevelId);
          if (thirdLevel) {
            thirdLevel.width = newWidth;
            this.$forceUpdate();
            return;
          }
        }
      }
    },

    // 初始化数据
    init() {
      // 如果有id，则是编辑模式，需要获取数据
      if (this.form.id) {
        this.get_module_data()
      } else {
        // 从路由参数中获取level值，默认为5（二级指标模版(新)）
        const level = this.$route.query.level;
        this.form.level = level ? parseInt(level) : 5;
      }
      this.get_rules()
    },

    // 获取模块数据（编辑模式使用）
    get_module_data() {
      get_module(this.form.id).then(res => {
        if (res.code === 0) {
          const data = res.data;

          this.form.templateName = data.templateName || '';
          this.form.background = data.background || '';
          this.form.level = Number(data.level) || 5;
          this.form.rules = data.rules || [];
          this.editable = data.editable !== undefined ? data.editable : true;

          // 处理规则数据（两级结构：一级指标 -> 指标）
          if (data.rules && data.rules.length > 0) {
            this.indicatorItems = [];

            data.rules.forEach(rule => {
              const firstLevelItem = {
                name: rule.name,
                maxScore: rule.maxScore || 0,
                children: []
              };

              if (rule.children && rule.children.length > 0) {
                rule.children.forEach(child => {
                  firstLevelItem.children.push(child);
                });
              }

              this.indicatorItems.push(firstLevelItem);
            });

            // 默认选中第一个一级指标
            if (this.indicatorItems.length > 0) {
              this.selectedFirstLevelId = this.indicatorItems[0].name;
              this.syncSelectedThirdLevelRules();
            }
          }
        }
      });
    },

    // 指标列表（复用三级指标库）
    get_rules() {
      return new Promise((resolve) => {
        rule_list({...this.rule_query, level: 3}).then(thirdRes => {
          this.thirdLevelRules = thirdRes.data
          resolve()
        }).catch(() => {
          console.log('加载指标失败')
          resolve()
        })
      })
    },

    // 校验模板名称字段
    validateTemplateName() {
      this.$refs['form'].validateField('templateName', (errorMessage) => {
        console.log('模板名称校验结果:', errorMessage);
      });
    },

    // 提交表单
    onSubmit() {
      const submitData = {
        id: this.form.id || null,
        templateName: this.form.templateName,
        background: this.form.background,
        level: this.form.level || 4,
        rules: []
      };

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.indicatorItems.forEach(firstLevel => {
            const rule = {
              name: firstLevel.name,
              maxScore: this.calculateFirstLevelScore(firstLevel),
              type: 'first',
              children: []
            };

            firstLevel.children.forEach(thirdLevel => {
              rule.children.push({
                id: thirdLevel.id || null,
                name: thirdLevel.name,
                maxScore: thirdLevel.maxScore || 0,
                type: 'third',
                displayType: thirdLevel.displayType || '1',
                width: thirdLevel.width || 24,
                agentCode: thirdLevel.agentCode || '',
                code: thirdLevel.code || '',
                isSys: thirdLevel.isSys || false,
              });
            });

            submitData.rules.push(rule);
          });

          save(submitData).then(res => {
            if (res.code === 0) {
              this.$message.success(this.form.id ? '编辑成功' : '新增成功');
              this.closeDrawer();
            } else {
              this.$message.error(res.message || (this.form.id ? '编辑失败' : '新增失败'));
            }
          });
        }
      });
    },

    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 关闭抽屉
    closeDrawer() {
      this.$router.go(-1)
    },

    // 添加一级指标
    addItem() {
      if (!this.newItemText.trim()) {
        this.$message.warning('请输入一级指标内容');
        return;
      }

      const newItem = {
        name: this.newItemText.trim(),
        maxScore: 0,
        children: []
      };

      this.indicatorItems.push(newItem);
      this.newItemText = '';
      // 新增后自动选中，方便继续添加指标
      this.selectedFirstLevelId = newItem.name;
      this.syncSelectedThirdLevelRules();
    },

    // 删除一级指标
    deleteItem(name) {
      const index = this.indicatorItems.findIndex(item => item.name === name);
      if (index > -1) {
        this.indicatorItems.splice(index, 1);

        if (this.selectedFirstLevelId === name) {
          this.selectedFirstLevelId = this.indicatorItems.length > 0 ? this.indicatorItems[0].name : null;
          this.currentFirstLevelId = this.selectedFirstLevelId;
          this.syncSelectedThirdLevelRules();
        }
        this.currentThirdLevelId = null;
      }
    },

    // 一级指标行样式
    firstLevelTableRowClassName({row}) {
      return row.name === this.selectedFirstLevelId ? 'current-row' : '';
    },

    // 处理一级指标当前行变化
    handleFirstLevelCurrentChange(currentRow) {
      this.selectedFirstLevelId = currentRow ? currentRow.name : null;
      this.currentFirstLevelId = this.selectedFirstLevelId;
      this.currentThirdLevelId = null;
      this.syncSelectedThirdLevelRules();
    },

    // 根据当前选中的一级指标，同步右侧多选框的选中项
    syncSelectedThirdLevelRules() {
      const firstLevel = this.indicatorItems.find(item => item.name === this.selectedFirstLevelId);
      if (firstLevel && firstLevel.children) {
        this.selectedThirdLevelRules = firstLevel.children.map(item => item.id);
      } else {
        this.selectedThirdLevelRules = [];
      }
    },

    // 指标选择变更事件处理 - 自动填充表格
    onThirdLevelRulesChange() {
      if (!this.selectedFirstLevelId) {
        this.$message.warning('请先选择一级指标');
        this.selectedThirdLevelRules = [];
        return;
      }

      const firstLevelItem = this.indicatorItems.find(item => item.name === this.selectedFirstLevelId);
      if (!firstLevelItem) {
        this.$message.warning('找不到对应的一级指标');
        return;
      }

      const selectedRuleIds = new Set(this.selectedThirdLevelRules);

      // 只保留id在选中集合中的项
      if (firstLevelItem.children) {
        firstLevelItem.children = firstLevelItem.children.filter(item => selectedRuleIds.has(item.id));
      } else {
        firstLevelItem.children = [];
      }

      // 添加新选择但尚未添加的指标
      selectedRuleIds.forEach(ruleId => {
        const exists = firstLevelItem.children.some(item => item.id === ruleId);
        if (!exists) {
          const rule = this.thirdLevelRules.find(r => r.id === ruleId);
          if (rule) {
            const newItem = {
              id: rule.id,
              name: rule.name,
              maxScore: rule.maxScore || 0,
              parentId: this.selectedFirstLevelId,
              agentCode: rule.agentCode,
              displayType: '1',
              width: 24,
              isSys: rule.isSys,
              code: rule.code,
            };
            firstLevelItem.children.push(newItem);
            this.currentThirdLevelId = newItem.id;
          }
        }
      });
    },

    // 删除指标
    deleteThirdItem(id) {
      for (const firstLevelItem of this.indicatorItems) {
        const index = firstLevelItem.children.findIndex(item => item.id === id);
        if (index > -1) {
          firstLevelItem.children.splice(index, 1);

          if (this.currentThirdLevelId === id) {
            this.currentThirdLevelId = null;
          }

          const ruleIndex = this.selectedThirdLevelRules.indexOf(id);
          if (ruleIndex > -1) {
            this.selectedThirdLevelRules.splice(ruleIndex, 1);
          }
          return;
        }
      }
    },

    // 处理指标当前行变化
    handleThirdLevelCurrentChange(currentRow) {
      this.currentThirdLevelId = currentRow ? currentRow.id : null;
    },

    // 扁平化指标数据用于表格显示 - 只显示当前选中一级指标下的指标
    flattenedThirdLevelItems() {
      const items = [];
      if (this.selectedFirstLevelId) {
        const selectedFirstLevel = this.indicatorItems.find(item => item.name === this.selectedFirstLevelId);
        if (selectedFirstLevel && selectedFirstLevel.children) {
          selectedFirstLevel.children.forEach(thirdLevel => {
            items.push({
              ...thirdLevel,
              firstLevelText: selectedFirstLevel.name
            });
          });
        }
      }
      return items;
    },
  },
  data() {
    return {
      drawer: true, //表单
      direction: 'rtl',//抽屉方向
      loading: false,
      form: {
        id: '',
        templateName: '', //名称
        background: '',//评课附加提示词
        level: 4,
        rules: []
      },
      rule_query: {name: ''},
      thirdLevelRules: [],//指标（复用三级指标库）
      editable: true, //判断指标项是否可编辑
      formRules: {
        templateName: [
          {required: true, message: '名称必填', trigger: ['blur', 'change']}
        ]
      },
      // 两级嵌套结构的评课指标数据
      newItemText: '', // 新增一级指标输入框的值
      indicatorItems: [], // 一级指标数组，包含嵌套的指标
      currentFirstLevelId: null, // 当前选中的一级指标
      currentThirdLevelId: null, // 当前选中的指标
      // 一级指标相关数据
      selectedFirstLevelId: null, // 选中的一级指标（以name标识）
      selectedThirdLevelRules: [] // 选中的指标数组
    };
  },
  created() {
    this.form.id = this.$route.query.id || ''
    this.init()
  },
}
</script>

<style lang="less" scoped>
// 全局样式重置，确保所有元素使用box-sizing
* {
  box-sizing: border-box;
}

.first-level-form {
  display: flex;
  flex-direction: column;
}

.third-level-form {

  .el-input-number__decrease,
  .el-input-number__increase {
    font-size: 10px !important;
    width: 20px !important;
  }

  /deep/ .el-input-number__decrease {
    font-size: 10px;
    width: 28px;
    background: none;
    color: white;
    background: #409EFF;
    border: none;
  }

  /deep/ .el-input-number__increase {
    font-size: 10px;
    width: 28px;
    background: #409EFF;
    color: white;
    border: none;
  }
}

// 整个抽屉内容容器
.drawer_form {
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;
  overflow: hidden;
}

// 表单容器
.demo-ruleForm {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}

// 表单内容区域（可滚动部分）
.form-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 20px;
  margin-bottom: 80px; // 为底部按钮留出空间
  width: 100%;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 123, 255, 0.1);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 123, 255, 0.5);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 123, 255, 0.7);
  }
}

// 表单元素样式
.form-input,
.form-select,
.form-textarea {
  width: 100%;
  border-radius: 4px;
  transition: all 0.3s;

  &:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

// 编辑模式下的蒙层样式
.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  pointer-events: all;
  user-select: none;
  border-radius: 10px;

  .edit-overlay-text {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  }
}

// 底部按钮区域
.form-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background-color: #052445;
  border-top: 1px solid rgba(0, 123, 255, 0.3);
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  box-sizing: border-box;
  z-index: 100;

  .cancel-btn,
  .submit-btn {
    min-width: 100px;
    padding: 8px 20px;
    font-size: 14px;
    border-radius: 4px;
  }

  .submit-btn {
    background-color: #007bff;
    border-color: #007bff;

    &:hover {
      background-color: #409eff;
      border-color: #409eff;
    }
  }
}

// Element UI 组件覆盖样式
/deep/ .el-form-item {
  margin-bottom: 20px;
}

/deep/ .el-form-item__label {
  color: #fff;
  font-weight: 500;
}

/deep/ .el-table__header-wrapper th {
  background-color: transparent;
  color: #fff;
  border-bottom: 1px solid rgba(0, 123, 255, 0.3);
}

/deep/ .el-table__body-wrapper td {
  background-color: transparent;
}

// 选中行样式
.current-row {
  background-color: rgba(0, 123, 255, 0.5) !important;
}

/deep/ .el-table__body tr.current-row > td {
  background-color: rgba(0, 123, 255, 0.5) !important;
  color: #fff;
  border-bottom: 1px solid rgba(0, 123, 255, 0.1);
}

/deep/ .el-table__row:hover td {
  background-color: rgba(0, 123, 255, 0.1);
}
</style>
